export enum RepresentationRequestType {
    USER_REQUEST = "USER_REQUEST",
    ENTERPRISE_REQUEST = "ENTERPRISE_REQUEST"
}